import { GetApiRequest } from '@/plugins/api/base'

export class GetTournaments extends GetApiRequest {
  constructor(context, data = {}) {
    const culture = context.i18n.locale.value

    const url = `api/results/${culture}/tournaments/sport${data.sportId}/${data.periodType}/${data.start}/${data.end}`
    super(context, url)
  }
}
